import React from 'react';
import { Link } from 'react-router-dom';
import Card from 'react-bootstrap/Card';

const submitTaskCard = () => {
	return (
		<Card style={{ width: '18rem' }}>
			<Card.Body>
				<Link to="/submitAssignment">
					<div className=" box">
						<div className="panel-course-submit_task">
							<div className="schedule_call_title">Submit Task</div>
							<div className="open-slot">Submit task to book next call</div>
							<i className="fa fa-file-o"></i>
						</div>
					</div>
				</Link>
			</Card.Body>
		</Card>
	);
};
export default submitTaskCard;
